//#region imports
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import "../App.css";
import _ from "lodash";
import ArbeitsplanContent from "../components/arbeitsplan/ArbeitsplanContent";
import {
  ArbeitsplanPageProps,
  ArbeitsplanType,
  Terminarten,
} from "../utils/types";
import { SubPageTitleWithUnderline } from "../components/common/SubPageTitleWithUnderline";
import { PageWrapper } from "../components/common/PageWrapper";
import { Typography } from "@mui/material";
//#endregion

const ArbeitsplanPage: React.FC<ArbeitsplanPageProps> = () => {
  const [arbeitsplane, setArbeitsplane] = useState<ArbeitsplanType[]>([]);
  const [dauerNachrichten, setDauerNachrichten] = useState<ArbeitsplanType[]>(
    []
  );
  useEffect(() => {
    const getArbeitsplan = async () => {
      const response = await fetch(`/api/getArbeitsplan/`, {
        cache: "no-cache",
      });
      const data = await response.json();
      setArbeitsplane(data);
      setDauerNachrichten(
        data.filter((ap) => ap.terminart === Terminarten.Dauernachricht)
      );
    };

    getArbeitsplan();
  }, []);
  return (
    <PageWrapper>
      {dauerNachrichten.length > 0 &&
        dauerNachrichten.map((ap, index) => (
          <div
            key={index}
            style={{
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {ap.bemerkung
              ?.split("\\n")
              .map((line, index) => (
                <Typography key={index}>{line}</Typography>
              ))}
          </div>
        ))}
      <SubPageTitleWithUnderline title="Alle Arbeitspläne" />
      <ArbeitsplanContent data={arbeitsplane} />
    </PageWrapper>
  );
};

export default ArbeitsplanPage;
